export default __webpack_public_path__ + "static/media/confirm-berth.b6f2a0ed.svg";